import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuardService } from "./services/authguard/auth-guard.service";
import { AppConstants } from "./constants/app-constants";
import { LoginPageComponent } from "./page/login-page/login-page.component";
import { ApplicationsPageComponent } from './page/applications-page/applications-page.component';
import { SupplierPageComponent } from './page/supplier-page/supplier-page.component';
import { GreenskyPageComponent } from './page/greensky-page/greensky-page.component';
import { CreditPlanPageComponent } from './page/credit-plan-page/credit-plan-page.component';
import { HomePageComponent } from './page/home-page/home-page.component';
import { UsersPageComponent } from './page/users-page/users-page.component';
import { BeyondSupplierPageComponent } from './page/beyond-supplier-page/beyond-supplier-page.component';
import { TerminationPageComponent } from './page/termination-page/termination-page.component';
import { ManualReviewPageComponent } from './page/manual-review-page/manual-review-page.component';

const routes: Routes = [
  {
    path: "",
    redirectTo: AppConstants.MENU_HOME,
    pathMatch: "full",
  },
  {
    path: AppConstants.MENU_HOME,
    component: HomePageComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: AppConstants.MENU_APPLICATIONS,
    component: ApplicationsPageComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: AppConstants.MENU_SUPPLIERS,
    component: SupplierPageComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: AppConstants.MENU_TRANSACTIONS,
    component: GreenskyPageComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: AppConstants.MENU_CREDIT_PLANS,
    component: CreditPlanPageComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: AppConstants.MENU_USERS,
    component: UsersPageComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: AppConstants.MENU_BEYOND_SUPPLIERS,
    component: BeyondSupplierPageComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: AppConstants.MENU_TERMINATIONS,
    component: TerminationPageComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: AppConstants.MENU_MANUAL_REVIEW,
    component: ManualReviewPageComponent,
    canActivate: [AuthGuardService],
  },
  { 
    path: 'login',
    component: LoginPageComponent,
  },
  {
    path: "**",
    redirectTo: AppConstants.MENU_HOME,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutesModule { }
